<template>
  <div id="deptMove" class="only-content">
    <div class="header">
      <Form
        :label-width="90"
        inline
        :model="params"
        ref="paramsForm"
        style="width: 100%"
      >
        <Row>
          <Col span="5">
            <FormItem label="业务员" prop="agentNameOrCode">
              <Input
                style="width: 162px"
                placeholder="请输入业务员姓名/代码"
                clearable
                v-model.trim="params.agentNameOrCode"
              />
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem label="所属机构" prop="customerCode">
              <Select
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="params.customerCode"
              >
                <Option
                  v-for="item in deptCodeAllList"
                  :value="item.deptCode"
                  :key="item.id"
                  placeholder="请选择机构名称/代码"
                  >{{ item.deptName }} / {{ item.deptCode }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <!-- <Col span="5">
                        <FormItem label="原职级名称" prop="rankCode">
                            <Select clearable transfer @on-open-change="selectUpDown" v-model.trim="params.rankCode">
                                <Option :value="item.rankCode" :key="item.id"  v-for="item in rankTypeList" placeholder="请选择原职级名称">{{item.rankName}} / {{item.rankCode}}</Option>
                            </Select>
                        </FormItem>
                    </Col> -->
          <Col span="5">
            <FormItem label="审核状态" prop="status">
              <Select
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="params.status"
                placeholder="请选择审核状态"
              >
                <Option value="0">通过</Option>
                <Option value="1">未通过</Option>
                <Option value="2">审批中</Option>
                <!-- <Option value="3">待提交</Option> -->
                <Option value="4">已撤回</Option>
                <!-- <Option value="6">已失效</Option> -->
              </Select>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem label="当前职级" prop="afterRankCode">
              <Select
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="params.afterRankCode"
              >
                <Option
                  :value="item.rankCode"
                  :key="item.id"
                  v-for="item in rankTypeList"
                  placeholder="请选择新职级名称"
                  >{{ item.rankName }} / {{ item.rankCode }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col style="float: right">
            <Button type="primary" @click="search">查询</Button>
            <Button @click="reset()">重置</Button>
          </Col>
        </Row>
        <div style="margin-bottom: 20px">
          <div id="moreBtn" class="searchUpDownBtn" style="margin-bottom: 6px">
            <Icon type="ios-arrow-down" @click="moreFun()" />
            <span @click="moreFun()">更多条件</span>
          </div>
          <div id="moreCondition">
            <Row>
              <!-- <Col span="5">
                <FormItem label="生效日期">
                  <DatePicker
                    transfer
                    v-model="params.effectiveDate"
                    @on-change="
                      (val) => {
                        params.effectiveDate = val;
                      }
                    "
                    type="date"
                    placeholder="请选择生效日期"
                  ></DatePicker>
                </FormItem>
              </Col> -->
              <!-- <Col span="5">
                <FormItem label="来源" prop="status">
                  <Select
                    clearable
                    transfer
                    @on-open-change="selectUpDown"
                    v-model.trim="params.applyFrom"
                    placeholder="请选择来源"
                  >
                    <Option value="0">异动申请</Option>
                    <Option value="1">考核结果</Option>
                  </Select>
                </FormItem>
              </Col> -->
              <!-- <Col span="5">
                                <FormItem label="审核状态" prop="status">
                                    <Select clearable transfer @on-open-change="selectUpDown" v-model.trim="params.status" placeholder="请选择审核状态">
                                        <Option value="0">通过</Option>
                                        <Option value="1">未通过</Option>
                                        <Option value="2">审批中</Option>
                                        <Option value="3">待提交</Option>
                                        <Option value="4">已撤回</Option>
                                        <Option value="6">已失效</Option>
                                </Select>
                                </FormItem>
                            </Col> -->
              <Col span="10">
                <FormItem label="日期类型" prop="dateType">
                  <Select
                    clearable
                    transfer
                    @on-open-change="selectUpDown"
                    v-model.trim="params.dateType"
                    placeholder="请选择日期类型"
                  >
                    <Option value="1">提交日期</Option>
                    <Option value="2">审批日期</Option>
                  </Select>
                  <DatePicker
                    transfer
                    type="daterange"
                    style="margin-left: 8px"
                    :value="params.date"
                    @on-change="
                      (date) => {
                        params.date = date;
                        params.startTime = date[0];
                        params.endTime = date[1];
                      }
                    "
                    placeholder="请选择日期范围"
                  ></DatePicker>
                </FormItem>
              </Col>
            </Row>
          </div>
          <div id="upBtn" class="searchUpDownBtn">
            <Icon type="ios-arrow-up" @click="upFun()" />
            <span @click="upFun()">收起</span>
          </div>
        </div>
      </Form>
    </div>
    <div style="margin-bottom: 15px">
      <Button
        type="primary"
        @click="quitApply('add')"
        v-if="button.moveApply_addPersonnel"
        >新增申请</Button
      >
      <Button type="warning" @click="agentCancel">一键撤回</Button>
    </div>
    <div>
      <primaryTable
        :columns="columns"
        :data="data"
        :total="total"
        :loading="tableLoading"
        @on-change="changePage"
        @on-page-size-change="changeSize"
      ></primaryTable>
    </div>

    <Modal
      class="Modal_html"
      title="人员调动申请"
      :footer-hide="isSee"
      v-model.trim="deptMoveModalFlag"
      width="1000"
      @on-visible-change="(val) => cancel('formValidate_dept', val)"
    >
      <Form
        ref="formValidate_dept"
        :disabled="isSee"
        :model="formValidate_dept"
        :rules="formValidate"
        :label-width="90"
        style="width: 100%"
      >
        <!-- 基本信息 -->
        <Row>
          <!-- <h3 class="marginLeft30" style="margin-left:20px;margin-bottom: 10px;">提交信息</h3> -->
          <Col span="12">
            <FormItem label="业务员" prop="agentCode">
              <!-- <InputModal
                labelWidth="120"
                :rules="[
                  {
                    required: true,
                    message: '请选择业务员编号',
                    trigger: 'blur,change',
                  },
                ]"
                :form.sync="formValidate_dept"
                value="agentCode"
                :disabled="isReady"
                :ApiList="[
                  { agentCode: 'agentCode' },
                  { agentName: 'agentName' },
                  { customerCode: 'customerCode' },
                  { customerName: 'customerName' },
                  { postCode: 'postCode' },
                  { postName: 'postName' },
                  { rankCode: 'rankCode' },
                  { rankName: 'rankName' },
                  { areaCode: 'areaCode' },
                  { areaName: 'areaName' },
                  { teamInfoCode: 'teamInfoCode' },
                  { teamInfoName: 'teamInfoName' },
                  { groupInfoCode: 'groupInfoCode' },
                  { groupInfoName: 'groupInfoName' },
                ]"
              /> -->
              <Select
                filterable
                transfer
                @on-open-change="selectUpDown"
                :disabled="isReady"
                clearable
                placeholder="请选业务员"
                v-model.trim="formValidate_dept.agentCode"
                @on-change="changePerson"
                v-if="!isReady"
              >
                <Option
                  :value="item.agentCode"
                  v-for="(item, index) in personList"
                  :key="index"
                  >{{ item.agentCode }} / {{ item.agentName }}</Option
                >
              </Select>
              <Input disabled v-else v-model.trim="agentCodeName" />
            </FormItem>
          </Col>
          <!-- <Col span="12">
            <FormItem label="业务员姓名" prop="agentName">
              <Input v-model.trim="formValidate_dept.agentName" disabled />
            </FormItem>
          </Col> -->
          <!-- <Col span="12">
            <FormItem label="管理机构代码" prop="customerCode">
              <Input v-model.trim="formValidate_dept.customerCode" disabled /> -->
          <!-- <Select clearable transfer @on-open-change="selectUpDown"  disabled v-model.trim="formValidate_dept.customerCode" clearn @on-change="getChildById(formValidate_dept.customerCode,'areaList','','',4)" >
                              <Option :value="item.deptCode" :key="item.id" v-for="item in transForList.customList">{{item.deptName}} / {{item.deptCode}}</Option>
                            </Select> -->
          <!-- </FormItem>
          </Col> -->
          <Col span="24" offset="">
            <FormItem prop="isRank">
              <Checkbox
                :disabled="isReady"
                v-model.trim="formValidate_dept.isRank"
                @on-change="changeRank"
                >职级调整</Checkbox
              >
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="当前职级" prop="rankCode">
              <Select
                clearable
                transfer
                @on-open-change="selectUpDown"
                disabled
                v-model.trim="formValidate_dept.rankCode"
                placeholder="请选择"
              >
                <Option
                  :value="item.rankCode"
                  :key="item.id"
                  v-for="item in rankTypeList"
                  >{{ item.rankName }} / {{ item.rankCode }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem
              label="变更为职级"
              prop="afterRankCode"
              v-if="formValidate_dept.isRank"
            >
              <Select
                clearable
                transfer
                @on-open-change="selectUpDown"
                :disabled="isReady || !formValidate_dept.isRank"
                v-model.trim="formValidate_dept.afterRankCode"
                placeholder="请选择"
                @on-change="selectChange"
              >
                <Option
                  :value="item.rankCode"
                  :key="item.id"
                  v-for="item in rankTypeLists"
                  >{{ item.rankName }} / {{ item.rankCode }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>

        <!--行政信息-->
        <Row>
          <Col span="24" offset="">
            <FormItem prop="isCompany">
              <Checkbox
                :disabled="isReady"
                v-model.trim="formValidate_dept.isCompany"
                @on-change="changeCompany"
                >机构调动</Checkbox
              >
            </FormItem>
          </Col>
          <!-- <Row v-if="formValidate_dept.isCompany">
            <Col span="12">
              <FormItem label="原营业区" prop="areaCode">
                <Select
                  clearable
                  transfer
                  @on-open-change="selectUpDown"
                  disabled
                  v-model.trim="formValidate_dept.areaCode"
                >
                  <Option
                    :value="item.marketCode"
                    :key="item.marketCode"
                    v-for="item in areaList"
                    >{{ item.marketName }} / {{ item.marketCode }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="原营业部" prop="teamInfoCode">
                <Select
                  clearable
                  transfer
                  @on-open-change="selectUpDown"
                  disabled
                  v-model.trim="formValidate_dept.teamInfoCode"
                >
                  <Option
                    :value="item.marketCode"
                    :key="item.marketCode"
                    v-for="item in teamList"
                    >{{ item.marketName }} / {{ item.marketCode }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="原营业组" prop="groupInfoCode">
                <Select
                  transfer
                  @on-open-change="selectUpDown"
                  v-model.trim="formValidate_dept.groupInfoCode"
                >
                  <Option
                    :value="item.deptCode"
                    :key="item.id"
                    v-for="item in groupList"
                    >{{ item.deptName }} / {{ item.deptCode }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row v-if="formValidate_dept.isCompany">
            <Col span="12">
              <FormItem label="新营业区" prop="afterAreaCode">
                <Select
                  clearable
                  transfer
                  @on-open-change="selectUpDown"
                  :disabled="isReady || allowWrite"
                  v-model.trim="formValidate_dept.afterAreaCode"
                  @on-change="
                    getChildById(
                      formValidate_dept.afterAreaCode,
                      'afterTeamList',
                      'afterAreaName',
                      'areaList',
                      5
                    )
                  "
                >
                  <Option
                    :value="item.marketCode"
                    :key="item.marketCode"
                    v-for="item in areaList"
                    >{{ item.marketName }} / {{ item.marketCode }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col v-show="isReady || isShowDept" span="12">
              <FormItem label="新营业部" prop="afterTeamCode">
                <Input :disabled="isReady||allowWrite" v-if="isSee" v-model.trim="formValidate_dept.afterTeamCodeAndName"/>
                                  <Select v-if="!isSee" :disabled="isReady||allowWrite" clearable transfer @on-open-change="selectUpDown" v-model.trim="formValidate_dept.afterTeamCode" @on-change="getChildById(formValidate_dept.afterTeamCode,'afterGroupList','afterTeamName','afterTeamList',6)">
                                    <Option :value="item.marketCode+'/'+item.marketName" :key="item.marketCode" v-for="item in afterTeamList">{{item.marketName}} / {{item.marketCode}}</Option>
                                </Select>
                <Select
                  :disabled="isReady || allowWrite"
                  clearable
                  transfer
                  @on-open-change="selectUpDown"
                  v-model.trim="formValidate_dept.afterTeamCode"
                  @on-change="
                    getChildById(
                      formValidate_dept.afterTeamCode,
                      'afterGroupList',
                      'afterTeamName',
                      'afterTeamList',
                      6
                    )
                  "
                >
                  <Option
                    :value="item.marketCode"
                    :key="item.marketCode"
                    v-for="item in afterTeamList"
                    >{{ item.marketName }} / {{ item.marketCode }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="新营业组" prop="afterGroupCode">
                <Select
                  transfer
                  @on-open-change="selectUpDown"
                  :disabled="isReady"
                  v-model.trim="formValidate_dept.afterGroupCode"
                  @on-change="
                    getNameByCode(
                      formValidate_dept.afterGroupCode,
                      'afterGroupName',
                      transForList.afterGroupList
                    )
                  "
                >
                  <Option
                    :value="item.marketCode"
                    :key="item.marketCode"
                    v-for="item in afterGroupList"
                    >{{ item.marketName }} / {{ item.marketCode }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row> -->
          <Col span="12">
            <FormItem label="当前机构">
              <!-- <Select
                clearable
                transfer
                @on-open-change="selectUpDown"
                disabled
                v-model.trim="formValidate_dept.ascriptionDept"
              >
                <Option
                  :value="item.ascriptionDept"
                  :key="item.id"
                  v-for="item in deptCodeList"
                  >{{ item.ascriptionDeptName }} / {{ item.ascriptionDept }}</Option
                >
              </Select> -->
              <Input v-model.trim="deptCodeName" disabled />
            </FormItem>
          </Col>
          <Col span="12" v-if="formValidate_dept.isCompany" :key="'1'">
            <FormItem label="转入机构" prop="toAscriptionDeptCode">
              <Select
                filterable
                clearable
                transfer
                @on-open-change="selectUpDown"
                v-model.trim="formValidate_dept.toAscriptionDeptCode"
                @on-change="changeDept"
                :disabled="isReady"
              >
                <Option
                  :value="item.deptCode"
                  :key="item.id"
                  v-for="item in deptCodeAllList"
                  >{{ item.deptName }} / {{ item.deptCode }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="生效日期">
              <!-- <DatePicker
              v-if="!isReady"
                :disabled="isReady"
                transfer
                type="date"
                v-model.trim="formValidate_dept.effectiveDate"
                clearable
                @on-change="
                  (val) =>
                    (formValidate_dept.effectiveDate =
                      val === '' ? '' : val)
                "
                style="width: 100%"
              ></DatePicker> -->
              <Input v-model.trim="formValidate_dept.effectiveDate" disabled />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="申请提交人" prop="date">
              <Input v-model.trim="formValidate_dept.createdUser" disabled />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="申请日期" prop="date">
              <DatePicker
                transfer
                type="date"
                clearable
                :value="formValidate_dept.submitDate"
                :on-change="
                  (date) => {
                    formValidate_dept.submitDate = date;
                  }
                "
                placeholder="请输入"
                disabled
                style="width: 100%"
              ></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <!--上传附件-->
        <!-- <Row>
          <h3
            class="marginLeft30"
            style="margin-left: 20px; margin-bottom: 10px"
          >
            附件
          </h3>
        </Row>
        <div>
          <FormItem class="fileStyle" label="上传文件" prop="files">
            <div style="display: flex; flex-wrap: wrap">
              <span
                v-for="(item, index) in formValidate_dept.files"
                :key="index"
              >
                <div class="demo-upload-list">
                  <img
                    :src="
                      $api.imgLoadUrl + item.filePath + '?sid=' + headers.sid
                    "
                  />
                  <div class="demo-upload-list-cover">
                    <Icon
                      type="ios-eye-outline"
                      @click.native="handleView(item)"
                    ></Icon>
                    <Icon
                      type="ios-trash-outline"
                      @click.native="delFormValidate_relationImage(item, index)"
                    ></Icon>
                  </div>
                </div>
                <div
                  style="text-align: center; width: 200px"
                  class="ellipsis"
                  :title="item.fileName"
                >
                  {{ item.fileName }}
                </div>
              </span>
            </div>
          </FormItem>
        </div>
        <Row v-if="!isSee">
          <FormItem label="">
            <div v-if="formValidate_dept.files.length < 20">
              <Upload
                :action="action"
                ref="upload"
                name="files"
                :on-success="handleSuccess"
                :show-upload-list="false"
                :format="['jpg', 'pdf', 'png']"
                :headers="headers"
                type="drag"
                :data="fileData"
                accept=".jpg,.pdf,.png"
              >
                <div style="height: 90px">
                  <Icon
                    type="ios-cloud-upload"
                    size="22"
                    style="color: #3399ff"
                  ></Icon>
                  <p>支持jpg/png格式图片；支持PDF文件</p>
                </div>
              </Upload>
            </div>
          </FormItem>
        </Row> -->
      </Form>

      <div slot="footer">
        <Button @click="cancel('formValidate_dept')">取消</Button>
        <Button
          :disabled="stopClickLogin"
          type="primary"
          @click="submit('1')"
          v-if="!isReady && !isEdit"
          >确认提交</Button
        >
        <!-- <Button
          type="primary"
          ghost
          @click="submit('0')"
          v-if="!isReady && !isEdit"
          >保存</Button
        > -->
        <Button
          :disabled="stopClickLogin"
          type="primary"
          @click="submit('2')"
          v-if="isEdit"
          >再次提交</Button
        >
      </div>
    </Modal>

    <Modal v-model.trim="auditModal" title="审批记录" width="900">
      <Row>
        <Col>
          <ModalLog
            :auditList="auditList"
            checkLogType="审批记录"
            :auditNo="auditNo"
          ></ModalLog>
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "deptMove",
  props: {
    headers: {
      type: Object,
    },
    rankTypeList: {
      type: Array,
    },
    companyList: {
      type: Object,
    },
  },
  data() {
    return {
      stopClickLogin: false, //点击防抖
      showMessage: false,
      checkBoxDisabled: false,
      allowWrite: true,
      isShowDept: false,
      isSee: false,
      rankTypeLists: [],
      button: this.$store.state.app.button,
      auditList: [],
      levelDisabled: {
        level4: false,
        level5: false,
        level6: false,
      },
      afterLevelDisabled: {
        level7: false,
        level8: false,
        level9: false,
      },

      auditModal: false,
      auditNo: "",
      fileData: {
        fileType: 3,
      },
      total: 0,
      tableLoading: false,
      params: {
        dateType: "",
        date: [],
        startTime: "",
        endTime: "",
        page: 1, //	否	string	页码
        pageSize: 10, //		否	string	长度
        agentNameOrCode: "", //		否	string	业务员姓名/编码
        customerCode: "", //		否	string	管理机构编码
        rankCode: "", //		否	string	原职级编码
        afterRankCode: "", //		否	string	异动后岗位编号
        subStartTime: "", //		否	string	提交开始时间
        subEndTime: "", //		否	string	提交结束时间
        flowStartTime: "", //		否	string	审核开始时间
        flowEndTime: "", //		否	string	审核结束时间
        effectiveDate: "",
        deptMove: "",
        effectiveStartDate: "", //		否	string	生效开始日期
        effectiveEndDate: "", //		否	string	生效结束日期
        status: "", //		否	int	审批状态 0.审批中 1.通过 2.未通过 3.待提交 4.已撤回5.不审批
        applyFrom: "",
      },
      isReady: false,
      isEdit: false,
      IsUpload: false,
      action: this.$api.enclosureUpload,
      formValidate_dept: {
        files: [],
        isRank: true,
        isCompany: true,
        agentCode: "", //	是	string	业务员编码
        agentName: "", //	是	string	业务员名称
        customerCode: "", //		是	string	管理机构编码
        customerName: "", //		是	string	管理机构名称
        rankCode: "", //		是	string	职级编码
        rankName: "", //		是	string	职级名称
        postCode: "", //		是	string	岗位编码
        postName: "", //		是	string	岗位名称
        areaCode: "", //		否	string	营业区编码
        areaName: "", //		否	string	营业区编码名称
        teamInfoCode: "", //		否	string	所属营业部编码
        teamInfoName: "", //		否	string	所属营业部名称
        groupInfoCode: "", //		否	string	所属营业组编码
        groupInfoName: "", //		否	string	所属营业组名称
        afterRankCode: "", //		是	string	异动后职级编码
        afterRankName: "", //		是	string	异动后职级名称
        afterAreaCode: "", //		否	string	营业区名称
        afterAreaName: "", //		否	string	营业区名称
        afterTeamCode: "", //		否	string	营业部编号
        afterTeamName: "", //		否	string	营业部名称
        afterGroupCode: "", //		否	string	营业组编号
        afterGroupName: "", //		否	string	营业组名称
        afterPostCode: "", //		否	string	异动后岗位编号
        afterPostName: "", //		否	string	异动后岗位名称
        effectiveDate: "", //是 string 生效日期
        deptMove: "",
        ascriptionDept: "", //原机构code
        ascriptionDeptName: "", //原机构name
        toAscriptionDeptCode: "", //转入机构name
        toAscriptionDeptName: "", //转入机构name
      },
      formValidate: {
        agentCode: [{ required: true, message: "请选择业务员编号" }],
        effectiveStartDate: [{ required: true, message: "请输入生效日期" }],
        effectiveDate: [
          {
            required: true,
            message: "生效日期不能为空",
            trigger: "change,blur",
          },
        ],
        afterAreaCode: [this.$util.rules.required()],
        afterRankCode: [this.$util.rules.required()],
        toAscriptionDeptCode: [this.$util.rules.required()],
        files: [
          /*  {required:true} */
        ],
      },
      deptMoveModalFlag: false,
      data: [
        {
          auditCode: "123",
        },
      ],
      //原
      areaList: [],
      teamList: [],
      groupList: [],
      //新
      afterAreaList: [],
      afterTeamList: [],
      afterGroupList: [],
      delFiledList: [],
      columns: [
        {
          title: "审批编号",
          key: "approvalId",
          align: "center",
          // fixed: 'left',
          minWidth: 140,
          render: (h, p) => {
            return h(
              "a",
              {
                on: {
                  click: () => {
                    this.quitApply("see", p.row);
                  },
                },
              },
              p.row.approvalId
            );
          },
        },
        {
          title: "业务员代码",
          key: "agentCode",
          align: "center",
          minWidth: 140,
        },
        {
          title: "业务员名称 ",
          key: "agentName",
          align: "center",
          minWidth: 140,
        },
        // {
        //   title: "管理机构代码",
        //   key: "customerCode",
        //   align: "center",
        //   minWidth: 150,
        // },
        {
          title: "当前所属机构",
          key: "ascriptionDeptName",
          align: "center",
          minWidth: 150,
        },
        {
          title: "转入机构",
          key: "toAscriptionDeptName",
          align: "center",
          minWidth: 150,
        },

        {
          title: "当前职级",
          key: "rankName",
          align: "center",
          minWidth: 100,
        },
        {
          title: "变更为职级",
          key: "afterRankName",
          align: "center",
          minWidth: 100,
        },
        // {
        //   title: "原营业区代码",
        //   key: "areaCode",
        //   align: "center",
        //   minWidth: 150,
        // },
        // {
        //   title: "原营业区名称",
        //   key: "areaName",
        //   align: "center",
        //   minWidth: 150,
        // },
        // {
        //   title: "新营业区代码",
        //   key: "afterAreaCode",
        //   align: "center",
        //   minWidth: 140,
        // },
        // {
        //   title: "新营业区名称",
        //   key: "afterAreaName",
        //   align: "center",
        //   minWidth: 140,
        // },
        // {
        //   title: "原营业部代码",
        //   key: "teamInfoCode",
        //   align: "center",
        //   minWidth: 140,
        // },
        // {
        //   title: "原营业部名称",
        //   key: "teamInfoName",
        //   align: "center",
        //   minWidth: 140,
        // },
        // {
        //   title: "新营业部代码",
        //   key: "afterTeamCode",
        //   align: "center",
        //   minWidth: 140,
        // },
        // {
        //   title: "新营业部名称",
        //   key: "afterTeamName",
        //   align: "center",
        //   minWidth: 140,
        // },
        {
          title: "生效日期",
          key: "effectiveDate",
          align: "center",
          minWidth: 100,
        },
        {
          title: "提交人",
          key: "modifiedUser",
          align: "center",
          minWidth: 140,
        },

        // {
        //   title: "申请来源",
        //   key: "applyFrom",
        //   align: "center",
        //   minWidth: 100,
        //   render: (h, params) => {
        //     let applyFrom = "";
        //     if (params.row.applyFrom == 0) {
        //       applyFrom = "异动申请";
        //     } else if (params.row.applyFrom == 1) {
        //       applyFrom = "考核结果";
        //     }
        //     return h("span", applyFrom);
        //   },
        // },
        {
          title: "提交日期",
          key: "submitDate",
          align: "center",
          minWidth: 140,
        },
        // {
        //   title: "审批日期",
        //   key: "approvalDate",
        //   align: "center",
        //   minWidth: 140,
        // },
        {
          title: "审批状态",
          key: "status",
          align: "center",
          minWidth: 140,
          render: (h, p) => {
            let text;
            let a = p.row.status;
            switch (a) {
              case 0:
                text = "通过";
                break;
              case 1:
                text = "未通过 ";
                break;
              case 2:
                text = "审批中";
                break;
              case 3:
                text = "待提交 ";
                break;
              case 4:
                text = "已撤回 ";
                break;
              case 5:
                text = "通过";
                break;
            }
            return h("div", text);
          },
        },
        {
          title: "操作",
          key: "",
          align: "center",
          fixed: "right",
          minWidth: 300,
          render: (h, p) => {
            return h("div", [
              this.button.moveApply_seePersonnel
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      // style:{
                      //     display:p.row.status!==4?'':'none'
                      // },
                      on: {
                        click: () => {
                          this.quitApply("ready", p.row);
                        },
                      },
                    },
                    "查看"
                  )
                : "",
              this.button.moveApply_editPersonnel
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                        disabled:
                          p.row.status == 3 || p.row.status == 4 ? false : true,
                      },
                      // style:{
                      //     display:p.row.status!==4?'':'none'
                      // },
                      on: {
                        click: () => {
                          this.quitApply("edit", p.row);
                        },
                      },
                    },
                    "编辑"
                  )
                : "",
              //   h('Button',{
              //       props:{
              //           type:'primary',
              //           size:'small',
              //           disabled:(p.row.status==0 || p.row.status==1 || p.row.status==5)?true:false
              //       },
              //       style:{
              //           display:p.row.status==4?'':'none'
              //       },
              //       on:{
              //           click:()=>{
              //               this.quitApply('edit',p.row)
              //           }
              //       }
              //   },'再次提交'),
              this.button.moveApply_withdrawPersonnel
                ? h(
                    "Button",
                    {
                      props: {
                        type: "error",
                        size: "small",
                        disabled: p.row.status != 2 ? true : false,
                      },
                      on: {
                        click: () => {
                          this.withdraw(p.row);
                        },
                      },
                    },
                    "撤回"
                  )
                : "",
              this.button.moveApply_recordPersonnel
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        ghost: true,
                        size: "small",
                        disabled: p.row.approvalId ? false : true,
                      },
                      on: {
                        click: () => {
                          this.getAuditList(p.row);
                        },
                      },
                    },
                    "审批记录"
                  )
                : "",
            ]);
          },
        },
      ],
      personList: [], // 业务员list
      deptCodeList: [], // 当前机构
      deptCodeAllList: [], // 转入机构
      deptCodeName: [], // 当前机构编码名称
      agentCodeName: "", // 业务员编码名称
    };
  },
  created() {
    if (
      !this.button.moveApply_withdrawPersonnel &&
      !this.button.moveApply_editPersonnel &&
      !this.button.moveApply_recordPersonnel
    ) {
      this.columns.pop();
    }
    this.getAllDeptCode();
  },
  mounted() {
    this.$api.getPostList({ enableStatus: "0" }).then((res) => {
      if (res.respCode == 0) {
        this.rankTypeLists = res.data;
      }
    });
    this.$nextTick(() => {
      document.getElementById("moreCondition").style.display = "none";
      document.getElementById("upBtn").style.display = "none";
    });
    this.search();
  },
  methods: {
    handleView(item) {
      window.open(
        this.$api.imgLoadUrl + item.filePath + "?sid=" + this.headers.sid
      );
    },
    //删除文件
    delFormValidate_relationImage(item, index) {
      this.formValidate_dept.files.splice(index, 1);
    },
    reset() {
      this.params.applyFrom = "";
      this.params = {};
      this.params.date = [];
      this.params.startTime = "";
      this.params.endTime = "";
      this.params.effectiveDate = "";
      this.params.deptMove = "";
      this.$refs.paramsForm.resetFields();
      this.search();
    },
    changeCompany(type) {
      this.formValidate_dept.afterAreaCode = "";
      this.formValidate_dept.afterAreaName = "";
      this.formValidate_dept.afterTeamCode = "";
      this.formValidate_dept.afterTeamName = "";
      this.formValidate_dept.afterGroupCode = "";
      this.formValidate_dept.afterGroupName = "";
      if (type) {
        this.formValidate_dept.isCompany = true;
      } else {
        this.formValidate_dept.isCompany = false;
        this.formValidate_dept.toAscriptionDeptCode = "";
        this.formValidate_dept.toAscriptionDeptName = "";
      }
    },
    //是否调动
    changeRank(type) {
      if (!type) {
        this.formValidate_dept.afterRankCode = this.formValidate_dept.rankCode;
        this.formValidate_dept.isRank = false;
      } else {
        this.formValidate_dept.afterRankCode = "";
        this.formValidate_dept.isRank = true;
      }
    },

    //旧机构显示
    getInfoById(code) {
      this.$api.getPostListById({ rankCode: code }).then((res) => {
        if (res.respCode == 0) {
          this.formValidate_dept.rankLevel = res.data[0].deptLevel;
          if (res.data[0].deptLevel <= 4) {
            this.isRankType = true;
            if (res.data[0].deptLevel < 4) {
              this.levelDisabled = {
                level4: false,
                level5: false,
                level6: false,
              };
            } else {
              this.levelDisabled = {
                level4: true,
                level5: false,
                level6: false,
              };
            }
          } else {
            this.isRankType = false;
            if (res.data[0].deptLevel == 5) {
              this.levelDisabled = {
                level4: true,
                level5: true,
                level6: false,
              };
            } else {
              this.levelDisabled = {
                level4: true,
                level5: true,
                level6: true,
              };
            }
          }
        }
      });
    },

    // 新机构显示
    afterAetInfoById(code) {
      for (let a = 0; a < this.rankTypeList.length; a++) {
        if (this.rankTypeList[a].rankCode === code) {
          this.formValidate_dept.afterRankName = this.rankTypeList[a].rankName;
        }
      }

      // this.$api.getPostListById({ rankCode: code }).then((res) => {
      //   if (res.respCode == 0) {
      //     if (res.data) {
      //       this.formValidate_dept.afterRankLevel =
      //         res.data[0] && res.data[0].deptLevel;
      //     }
      //     if ((res.data && res.data[0] && res.data[0].deptLevel) <= 4) {
      //       if (res.data[0].deptLevel < 4) {
      //         this.afterLevelDisabled = {
      //           level7: false,
      //           level8: false,
      //           level9: false,
      //         };
      //       } else {
      //         this.afterLevelDisabled = {
      //           level7: true,
      //           level8: false,
      //           level9: false,
      //         };
      //       }
      //     } else {
      //       this.isRankType = false;
      //       if ((res.data && res.data[0] && res.data[0].deptLevel) == 5) {
      //         this.afterLevelDisabled = {
      //           level7: true,
      //           level8: true,
      //           level9: false,
      //         };
      //       } else {
      //         this.afterLevelDisabled = {
      //           level7: true,
      //           level8: true,
      //           level9: true,
      //         };
      //       }
      //     }
      //   }
      // });
    },
    //分页改变
    changePage(page) {
      this.params.page = page;
      this.getTransForPage();
    },
    // 分页size
    changeSize(size) {
      this.params.pageSize = size;
      this.getTransForPage();
    },
    //审批记录
    getAuditList(row) {
      this.$api
        .getActivityHis({ processInstanceId: row.approvalId })
        .then((res) => {
          if (res.respCode == 0) {
            this.auditModal = true;
            this.auditNo = row.approvalId;
            this.auditList = res.data;
          } else {
            this.$Message.error(res.message);
          }
        });
    },
    //分页
    getTransForPage() {
      if (this.params.dateType == 1) {
        this.params.subStartTime = this.params.startTime;
        this.params.subEndTime = this.params.endTime;
      } else if (this.params.dateType == 2) {
        this.params.flowStartTime = this.params.startTime;
        this.params.flowEndTime = this.params.endTime;
      }
      this.tableLoading = true;
      this.$api.getTransForPage(this.params).then((res) => {
        this.tableLoading = false;
        if (res.respCode == 0) {
          this.data = res.data.list;
          this.total = res.data.total;
        } else {
          this.$Message.error(res.resultMessage);
        }
      });
    },
    //查询
    search() {
      this.params.page = 1;
      this.getTransForPage();
      // 业务员下拉选
      this.getExcludeInActivity();
    },

    //删除图片
    delFiled(item, index) {
      if (item.id) {
        this.formValidate_dept.files[index].isDelete = 1;
        this.delFiledList.push(this.formValidate_dept.files[index]);
      }
      this.formValidate_dept.files.splice(index, 1);
    },
    //文件上传
    handleSuccess(res, file, fileList) {
      if (res.content.success) {
        res.content.content.files[0].isDelete = 0;
        this.formValidate_dept.files.push(res.content.content.files[0]);
      } else {
        if (res.content.content != null) {
          this.$Message.error(res.content.content);
        } else {
          this.$Message.error(res.resultMessage);
        }
      }
    },

    cancel(form, flag) {
      if (!flag) {
        this.deptMoveModalFlag = false;
        this.$refs[form].resetFields();
      }
    },
    //调用新增申请
    createTransFor(type) {
      this.formValidate_dept.subType = type;
      this.formValidate_dept.files.concat(this.delFiledList);
      console.log(this.formValidate_dept, "this.formValidate_dept");
      this.$api.transferCreate(this.formValidate_dept).then((res) => {
        if (res.respCode == 0) {
          if (type == "2") {
            this.$Message.success("编辑成功");
          } else {
            this.$Message.success("新增成功");
          }
          this.deptMoveModalFlag = false;
          this.search();
        } else {
          this.$Message.error(res.content ? res.content : res.resultMessage);
        }
      });
    },
    //新增申请
    submit(type) {
      this.stopClickLogin = true;
      setTimeout(() => {
        this.stopClickLogin = false;
      }, 2000);

      /*   if(this.formValidate_dept.files.length==0){
                     this.$Message.error({
                         content:"请上传文件",
                         duration:5
                     })
                     return
                } */
      this.$refs.formValidate_dept.validate((item) => {
        this.formValidate_dept.triggerType = 0; //triggerType 0-异动申请 1-考核调整
        console.log(this.formValidate_dept.afterTeamCodeAndName);
        if (this.formValidate_dept.afterTeamCodeAndName) {
          this.formValidate_dept.afterTeamCode =
            this.formValidate_dept.afterTeamCodeAndName.split("/")[0];
          this.formValidate_dept.afterTeamName =
            this.formValidate_dept.afterTeamCodeAndName.split("/")[1];
        }
        // if (this.showMessage) {
        //   this.$Message.info("原营业部与新营业部不可相同");
        //   return false;
        // }
        if (
          !this.formValidate_dept.isRank &&
          !this.formValidate_dept.isCompany
        ) {
          this.$Message.info("请选择调动类型，否则不能提交");
          return false;
        }
        // if (
        //   this.formValidate_dept.isRank &&
        //   this.formValidate_dept.isCompany &&
        //   !this.formValidate_dept.afterRankCode &&
        //   !this.formValidate_dept.afterAreaCode
        // ) {
        //   this.$Message.info("人员调动信息为空，不能提交");
        //   return false;
        // }
        if (
          this.formValidate_dept.isRank &&
          !this.formValidate_dept.afterRankCode
        ) {
          this.$Message.info("新职级名称不能为空");
          return false;
        }
        // if (
        //   this.formValidate_dept.isCompany &&
        //   this.formValidate_dept.afterRankLevel == 4 &&
        //   !this.formValidate_dept.afterAreaCode
        // ) {
        //   this.$Message.info("新机构不能为空");
        //   return false;
        // }
        // if (
        //   this.formValidate_dept.isCompany &&
        //   this.formValidate_dept.afterRankLevel == 5 &&
        //   !this.formValidate_dept.afterAreaCode &&
        //   !this.formValidate_dept.afterTeamCode
        // ) {
        //   this.$Message.info("新机构不能为空");
        //   return false;
        // }
        // if (
        //   this.formValidate_dept.isCompany &&
        //   this.formValidate_dept.afterRankLevel == 6 &&
        //   !this.formValidate_dept.afterAreaCode &&
        //   !this.formValidate_dept.afterTeamCode &&
        //   !this.formValidate_dept.afterGroupCode
        // ) {
        //   this.$Message.info("新机构不能为空");
        //   return false;
        // }
        if (
          this.formValidate_dept.isRank &&
          this.formValidate_dept.afterRankCode ==
            this.formValidate_dept.rankCode
        ) {
          this.$Message.info("原职级名称与新职级名称不可相同");
          return false;
        }
        // if (
        //   this.formValidate_dept.isCompany &&
        //   this.formValidate_dept.afterRankLevel == 4 &&
        //   this.formValidate_dept.afterAreaCode ==
        //     this.formValidate_dept.areaCode
        // ) {
        //   this.$Message.info("原机构与新机构不可相同");
        //   return false;
        // }
        // if (
        //   this.formValidate_dept.isCompany &&
        //   this.formValidate_dept.afterRankLevel == 5 &&
        //   this.formValidate_dept.afterTeamCode ==
        //     this.formValidate_dept.teamInfoCode
        // ) {
        //   this.$Message.info("原机构与新机构不可相同");
        //   return false;
        // }
        // if (
        //   this.formValidate_dept.isCompany &&
        //   this.formValidate_dept.afterRankLevel == 6 &&
        //   this.formValidate_dept.afterGroupCode ==
        //     this.formValidate_dept.groupInfoCode
        // ) {
        //   this.$Message.info("原机构与新机构不可相同");
        //   return false;
        // }
        //
        // if (this.formValidate_dept.isCompany) {
        //   if (!this.formValidate_dept.afterAreaCode) {
        //     // ||  HXE不让填写新营业部，其余的都要显示
        //     //当管理机构是营业部级别时候，不显示营业部
        //     //当机构调动没有勾选时候，不提示
        //     this.$Message.info("新营业区信息不能为空");
        //     return false;
        //   }
        // }
        // if (this.isShowDept && !this.formValidate_dept.afterTeamCode) {
        //   //当机构调动没有勾选时候，不提示
        //   if (this.formValidate_dept.isCompany) {
        //     this.$Message.info("新营业部信息不能为空");
        //     return false;
        //   }
        // }
        this.formValidate_dept.applyFrom = 0;
        this.createTransFor(type);
      });
    },
    //根据code对name
    getNameByCode(code, name, list) {
      for (let a = 0; a < list.length; a++) {
        if (list[a].deptCode == code) {
          this.formValidate_dept[name] = list[a].deptName;
        }
      }
    },

    //获取下级机构
    getChildById(code, list, name, codeList, deptId) {
      this.getChild(code, deptId, this, (arr) => {
        this[list] = arr;
        if (this[codeList]) {
          this[codeList].map((item) => {
            if (item.marketCode === code) {
              this.formValidate_dept[name] = item.marketName;
            }
          });
        }
      });
    },
    quitApply(type, params) {
      this.isSee = false;
      if (type === "add") {
        this.isReady = false;
        this.isEdit = false;
        this.$refs.formValidate_dept.resetFields();
        this.formValidate_dept = {
          files: [],
          isRank: true,
          isCompany: true,
          agentCode: "", //	是	string	业务员编码
          agentName: "", //	是	string	业务员名称
          customerCode: "", //		是	string	管理机构编码
          customerName: "", //		是	string	管理机构名称
          rankCode: "", //		是	string	职级编码
          rankName: "", //		是	string	职级名称
          postCode: "", //		是	string	岗位编码
          postName: "", //		是	string	岗位名称
          areaCode: "", //		否	string	营业区编码
          areaName: "", //		否	string	营业区编码名称
          teamInfoCode: "", //		否	string	所属营业部编码
          teamInfoName: "", //		否	string	所属营业部名称
          groupInfoCode: "", //		否	string	所属营业组编码
          groupInfoName: "", //		否	string	所属营业组名称
          afterRankCode: "", //		是	string	异动后职级编码
          afterRankName: "", //		是	string	异动后职级名称
          afterAreaCode: "", //		否	string	营业区名称
          afterAreaName: "", //		否	string	营业区名称
          afterTeamCode: "", //		否	string	营业部编号
          afterTeamName: "", //		否	string	营业部名称
          afterGroupCode: "", //		否	string	营业组编号
          afterGroupName: "", //		否	string	营业组名称
          afterPostCode: "", //		否	string	异动后岗位编号
          afterPostName: "", //		否	string	异动后岗位名称
          effectiveDate: "", //是 string 生效日期,
          deptMove: "",
          ascriptionDept: "", //原机构code
          ascriptionDeptName: "", //原机构name
          toAscriptionDeptCode: "", //转入机构name
          toAscriptionDeptName: "", //转入机构name
        };
      } else if (type === "ready") {
        this.isSee = true;
        this.isReady = true;
        this.isEdit = false;
        this.formValidate_dept = this.newData(params);
        this.agentCodeName =
          this.formValidate_dept.agentCode +
          "/" +
          this.formValidate_dept.agentName;
        this.formValidate_dept.isRank = this.formValidate_dept.afterRankCode
          ? true
          : false;
        this.formValidate_dept.isCompany = this.formValidate_dept
          .toAscriptionDeptCode
          ? true
          : false;
        // let tempObj=this.personList.find(
        //   (item) => item.agentCode == this.formValidate_dept.agentCode
        // )
        // if(tempObj){
        //   let objTemp =tempObj.agentId;
        //   this.getDeptCode(objTemp);
        // }
        this.deptCodeName =
          this.formValidate_dept.ascriptionDeptName +
          "/" +
          this.formValidate_dept.ascriptionDept;
      } else if (type === "edit") {
        this.isReady = false;
        this.isEdit = true;
        //  this.formValidate_dept
        let obj = JSON.parse(JSON.stringify(params));
        if (obj.type === "0") {
          obj.isRank = true;
        } else if (obj.type === "1") {
          obj.isCompany = true;
        } else if (obj.type === "2") {
          obj.isRank = true;
          obj.isCompany = true;
        }
        this.formValidate_dept = obj;
        // let tempObj=this.personList.find(
        //   (item) => item.agentCode == this.formValidate_dept.agentCode
        // )
        // if(tempObj){
        //   let objTemp =tempObj.agentId;
        //   this.getDeptCode(objTemp);
        // }
        this.deptCodeName =
          this.formValidate_dept.ascriptionDeptName +
          "/" +
          this.formValidate_dept.ascriptionDept;
        // this.formValidate_dept.isRank=this.formValidate_dept.afterRankCode?true:false
        // this.formValidate_dept.isCompany=this.formValidate_dept.toAscriptionDeptCode?true:false
      } else {
        let obj = JSON.parse(JSON.stringify(params));
        if (obj.type === "0") {
          obj.isRank = true;
        } else if (obj.type === "1") {
          obj.isCompany = true;
        } else if (obj.type === "2") {
          obj.isRank = true;
          obj.isCompany = true;
        }
        this.isSee = true;
        this.formValidate_dept = this.newData(obj);
        this.formValidate_dept.afterTeamCodeAndName =
          this.formValidate_dept.afterTeamName +
          "/" +
          this.formValidate_dept.afterTeamCode;
        this.deptCodeName =
          this.formValidate_dept.ascriptionDeptName +
          "/" +
          this.formValidate_dept.ascriptionDept;
      }
      // this.$refs.formValidate_dept.resetFields()
      // this.formValidate_dept = {
      //     files:[],
      //     isRank:true,
      //     isCompany:true,
      //     agentCode:'',//	是	string	业务员编码
      //     agentName:'',//	是	string	业务员名称
      //     customerCode:'',//		是	string	管理机构编码
      //     customerName:'',//		是	string	管理机构名称
      //     rankCode:'',//		是	string	职级编码
      //     rankName:'',//		是	string	职级名称
      //     postCode:'',//		是	string	岗位编码
      //     postName:'',//		是	string	岗位名称
      //     areaCode:'',//		否	string	营业区编码
      //     areaName:'',//		否	string	营业区编码名称
      //     teamInfoCode:'',//		否	string	所属营业部编码
      //     teamInfoName:'',//		否	string	所属营业部名称
      //     groupInfoCode:'',//		否	string	所属营业组编码
      //     groupInfoName:'',//		否	string	所属营业组名称
      //     afterRankCode:'',//		是	string	异动后职级编码
      //     afterRankName:'',//		是	string	异动后职级名称
      //     afterAreaCode:'',//		否	string	营业区名称
      //     afterAreaName:'',//		否	string	营业区名称
      //     afterTeamCode:'',//		否	string	营业部编号
      //     afterTeamName:'',//		否	string	营业部名称
      //     afterGroupCode:'',//		否	string	营业组编号
      //     afterGroupName:'',//		否	string	营业组名称
      //     afterPostCode:'',//		否	string	异动后岗位编号
      //     afterPostName:'',//		否	string	异动后岗位名称
      //     effectiveDate:'',//是 string 生效日期
      // }
      this.deptMoveModalFlag = true;
    },

    //撤回
    withdraw(row) {
      this.$util.confirmDialog(
        this,
        "确认撤回",
        "确认撤回该条审批申请吗？一旦撤回将无法恢复!",
        (self) => {
          this.$api.withdrawTransfer({ changeId: row.id }).then((res) => {
            if (res.success) {
              this.$Message.success("撤回成功");
              this.params.page = 1;
              this.search();
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      );
    },
    //获取业务员
    getExcludeInActivity() {
      this.$api.excludeInActivity({}).then((res) => {
        if (res.result == 0) {
          this.personList = res.content;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //一键提交
    agentSbumit() {},
    //一键撤回
    agentCancel() {
      this.$util.confirmDialog(
        this,
        "确认提示",
        "确认继续此项操作吗？确认后将无法撤回",
        () => {
          this.$api.batchTransfer().then((res) => {
            if (res.result == 0) {
              this.params.page = 1;
              this.search();
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      );
    },
    //获取当前机构
    getDeptCode(agentId) {
      this.$api.getDeptCode({ agentId: agentId }).then((res) => {
        if (res.result == 0) {
          // this.deptCodeList=res.content
          this.formValidate_dept.ascriptionDept = res.content.ascriptionDept;
          this.formValidate_dept.ascriptionDeptName =
            res.content.ascriptionDeptName;
          this.deptCodeName =
            res.content.ascriptionDeptName + "/" + res.content.ascriptionDept;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //获取所有机构
    getAllDeptCode() {
      this.$api.getDeptInfoBytenementNo().then((res) => {
        if (res.result == 0) {
          this.deptCodeAllList = res.content;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //选择转入机构
    changeDept(data) {
      this.formValidate_dept.toAscriptionDeptCode = data;
      this.formValidate_dept.toAscriptionDeptName = this.deptCodeAllList.find(
        (item) => item.deptCode == data
      ).deptName;
    },
    //选择业务员
    changePerson(data) {
      let obj = this.personList.find((item) => item.agentCode == data);
      this.formValidate_dept.agentCode = data;
      this.formValidate_dept.agentName = obj.agentName;
      this.formValidate_dept.customerCode = obj.customerCode;
      this.formValidate_dept.customerName = obj.customerName;
      this.formValidate_dept.areaCode = obj.areaCode;
      this.formValidate_dept.areaName = obj.areaName;
      this.formValidate_dept.rankCode = obj.rankCode;
      this.formValidate_dept.rankName = obj.rankName;
      this.formValidate_dept.teamInfoCode = obj.teamInfoCode;
      this.formValidate_dept.teamInfoName = obj.teamInfoName;
      this.formValidate_dept.groupCode = obj.groupInfoCode;
      this.formValidate_dept.groupName = obj.groupInfoName;
      this.formValidate_dept.postCode = obj.postCode;
      this.formValidate_dept.postName = obj.postName;
      // 当前机构
      this.getDeptCode(obj.agentId);
    },
    //新职位选择
    selectChange(data) {
      this.formValidate_dept.afterRankCode = data;
      this.formValidate_dept.afterRankName = this.rankTypeLists.find(
        (item) => item.rankCode == data
      ).rankName;
    },
  },

  watch: {
    // "formValidate_dept.afterTeamCodeAndName"(o) {
    //   //原营业部和新营业部不能一样
    //   if (o && o.split("/")[0] == this.formValidate_dept.teamInfoCode) {
    //     this.showMessage = true;
    //   } else {
    //     this.showMessage = false;
    //   }
    // },
    // "formValidate_dept.isCompany"(o, v) {
    //   if (!o) {
    //     this.formValidate_dept.afterAreaCode = "";
    //     this.formValidate_dept.afterTeamCode = "";
    //     this.formValidate_dept.afterGroupCode = "";

    //     this.formValidate_dept.toAscriptionDeptCode = "";
    //     this.formValidate_dept.toAscriptionDeptName = "";
    //   }
    // },
    //当职级名称跳转按钮false时候，根据原职级名称判断，否则根据新职级名称
    // "formValidate_dept.isRank"(o, v) {
    //   console.log(o);
    //formValidate_dept.rankCode
    // if (o && this.formValidate_dept.rankCode == "string") {
    //   if (
    //     typeof this.formValidate_dept.rankCode.splice("/") == "object" &&
    //     this.formValidate_dept.rankCode.splice("/")[1].slice(0, 3) == "HXE"
    //   ) {
    //     this.allowWrite = false;
    //   } else {
    //     this.isShowDept = true;
    //   }
    //   //this.allowWrite=this.
    // } else {
    //   if (
    //     this.formValidate_dept.afterRankCode &&
    //     this.formValidate_dept.afterRankCode.slice(0, 3) == "HXE"
    //   ) {
    //     this.isShowDept = false;
    //   } else {
    //     this.isShowDept = true;
    //   }
    // }
    //   if (!o) {
    //     this.checkBoxDisabled = false;
    //     //清空新职级名称
    //     this.formValidate_dept.afterRankCode = "";
    //   }
    // },
    // formValidate_dept(o, v) {
    //   console.log(o);
    //   //监听原职级名称，如果职级名称调整按钮勾选了那么就判断 新职级名称
    //   if (o && o.agentCode) {
    //     //有值了 才让其余的可填写
    //     this.allowWrite = false;
    //   } else {
    //     this.allowWrite = true;
    //   }
    // },
    //监听机构code 区把新旧机构的区部组展示
    // "formValidate_dept.customerCode"(o, v) {
    //   if (o) {
    //     this.getChildById(o, "areaList", "", "", 4);
    //   }
    // },
    // "formValidate_dept.areaCode"(o, v) {
    //   if (o) {
    //     this.getChildById(o, "teamList", "", "", 5);
    //   }
    // },
    // "formValidate_dept.teamInfoCode"(o, v) {
    //   if (o) {
    //     this.getChildById(o, "groupList", "", "", 6);
    //   }
    // },
    // //监听职级是否显示区部组
    // "formValidate_dept.rankCode"(o, v) {
    //   //当选择的是HXE开头的时候，不显示新营业部 否则显示
    //   if (o && o.slice(0, 3) == "HXE") {
    //     this.isShowDept = false;
    //   } else {
    //     this.isShowDept = true;
    //   }
    // },
    //监听职级是否显示新的区部组
    // "formValidate_dept.afterRankCode"(o, v) {
    //   if (o) {
    //     console.log(o);
    //     this.afterAetInfoById(o);
    //     //新职级名称有值了。就根据他判断是不是HXE,是的话不显示新营业部，否则显示
    //     if (o.slice(0, 3) == "HXE") {
    //       this.isShowDept = false;
    //     } else {
    //       this.isShowDept = true;
    //     }
    //     //当新职级名称有值得时候，判断和原职级名称是否同一级（编码前五位一样就是同一级别），不是的话下面的机构调动按钮必须勾选。反之随意。
    //     if (this.formValidate_dept.rankCode) {
    //       if (o.slice(0, 3) != this.formValidate_dept.rankCode.slice(0, 3)) {
    //         this.formValidate_dept.isCompany = true;
    //         this.checkBoxDisabled = true;
    //       } else {
    //         this.checkBoxDisabled = false;
    //       }
    //     }
    //     this.formValidate_dept.isRank=true
    //   } else {
    //     this.checkBoxDisabled = false;
    //     this.formValidate_dept.isRank=false
    //   }
    // },
    //清空校验以及触发false 情况下新旧职级问题
    "formValidate_dept.agentCode"(m, v) {
      if (m) {
        //可能遇到change之后表单的校验不清除  所有需要重置一下 并赋值
        this.$refs.formValidate_dept.fields.forEach((e) => {
          if (e.prop == "agentCode") {
            e.resetField();
            this.formValidate_dept.agentCode = m;
          }
        });
        if (!this.formValidate_dept.isRank) {
          this.formValidate_dept.afterRankCode =
            this.formValidate_dept.rankCode;
        }
      }
    },
  },
  computed: {
    "transForList.afterAreaList"() {
      return this.transForList.afterAreaList;
    },
    "transForList.afterTeamList"() {
      return this.transForList.afterTeamList;
    },
    "transForList.afterGroupList"() {
      return this.transForList.afterGroupList;
    },

    transForList() {
      return this.companyList;
    },
  },
};
</script>

<style scoped lang="less">
#deptMove {
  .header {
    .ivu-input,
    .ivu-select,
    .ivu-date-picker {
      width: 162px;
    }
  }
}
.fileStyle /deep/ .ivu-form-item-error-tip {
  display: none !important;
}
</style>
